import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";

export const Route = createFileRoute("/about")({
  head: () => {
    const title = "About Mohnish Nagpal & MNRE | Mumbai Luxury Real Estate Advisory";
    const description = "Learn about Mohnish Nagpal Real Estate (MNRE) — 15+ years advising HNIs, families, and corporates across Mumbai Western Suburbs, South Mumbai, and BKC.";
    const canonicalUrl = "https://mnre.in/about";
    const ogImage = "https://mnre.in/lovable-uploads/abe5bbca-52aa-4071-ba12-16af51cf5fac.webp";

    const breadcrumbJsonLd = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://mnre.in/" },
        { "@type": "ListItem", position: 2, name: "About Us", item: canonicalUrl },
      ],
    };

    const aboutPageJsonLd = {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "About Mohnish Nagpal Real Estate (MNRE)",
      url: canonicalUrl,
      description: description,
      mainEntity: {
        "@type": "Person",
        name: "Mohnish Nagpal",
        jobTitle: "Founder & Principal Real Estate Advisor",
        worksFor: {
          "@type": "RealEstateAgent",
          name: "Mohnish Nagpal Real Estate",
          url: "https://mnre.in/",
        },
        address: {
          "@type": "PostalAddress",
          streetAddress: "Ajanta Building, 3rd Road",
          addressLocality: "Khar West",
          addressRegion: "Mumbai, Maharashtra",
          postalCode: "400052",
          addressCountry: "IN",
        },
        sameAs: [
          "https://www.facebook.com/mohnishnagpalOfficial",
          "https://www.instagram.com/mohnish.nagpal/",
        ],
      },
    };

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonicalUrl },
        { property: "og:image", content: ogImage },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: ogImage },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify([breadcrumbJsonLd, aboutPageJsonLd]),
        },
      ],
    };
  },
  component: About,
});
